/* NOPAL LIFE — Dossier Peau : rendu des 10 blocs (T6).
   Usage : renderDossier(dossier, mountEl, { prenom })  — dossier = réponse /v1/diagnostic. */
(function () {
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
    })
  }

  var SUBS = [
    ['hydratation', 'Hydratation'],
    ['eclat', 'Éclat'],
    ['uniformite', 'Uniformité du teint'],
    ['fermete', 'Fermeté'],
    ['confort', 'Confort'],
    ['regularite', 'Régularité de routine'],
  ]

  var EXPLAIN = {
    hydratation: 'Des tiraillements ou un inconfort traduisent un besoin d’hydratation et de confort au quotidien.',
    eclat: 'Un teint terne peut venir de la fatigue cutanée, du stress, du manque de sommeil ou d’un renouvellement ralenti.',
    uniformite: 'Les irrégularités du teint peuvent être favorisées par l’exposition solaire, les variations hormonales ou l’inflammation.',
    fermete: 'La perte de tonicité perçue est favorisée par le temps, les variations hormonales et le manque de nutrition.',
    confort: 'Une peau réactive demande de la douceur et un soutien de la barrière cutanée.',
    regularite: 'Une routine plus régulière — et une protection solaire quotidienne — soutient durablement les résultats.',
  }

  function pct(n) { return Math.max(0, Math.min(100, Number(n) || 0)) }

  function hero(d, prenom) {
    var prios = (d.priorites_detail || []).map(function (p) {
      return '<span class="chip"><b>' + esc(p.label) + '</b></span>'
    }).join('')
    return (
      '<section class="hero">' +
      '<div class="eyebrow">Votre Dossier Peau NOPAL LIFE</div>' +
      '<h1>Bonjour ' + esc(prenom) + '</h1>' +
      '<p class="lede">Votre peau est identifiée comme <b>' + esc(d.type_peau || '—') +
      '</b>. Voici votre profil cosmétique personnalisé et vos priorités.</p>' +
      '<div class="chips">' + prios + '</div>' +
      '</section>'
    )
  }

  function scoreBlock(d) {
    var s = d.score || {}
    var subs = SUBS.map(function (k) {
      var v = pct(s[k[0]])
      return (
        '<div class="sub"><span>' + esc(k[1]) + '</span>' +
        '<span class="bar"><i style="width:' + v + '%"></i></span>' +
        '<span class="v">' + v + '</span></div>'
      )
    }).join('')
    return (
      '<section><div class="eyebrow">Bloc 2 — Score peau</div>' +
      '<h2>Votre score global</h2>' +
      '<div class="score-wrap">' +
      '<div class="ring" style="--val:' + pct(s.global) + '"><div class="inner">' +
      '<div><div class="num">' + pct(s.global) + '</div><div class="den">/ 100</div></div></div></div>' +
      '<div class="subs">' + subs + '</div></div>' +
      '<p class="interp">' + esc(d.interpretation || '') + '</p>' +
      '<p class="disclaimer">' + esc(d.disclaimer || '') + '</p>' +
      '</section>'
    )
  }

  function problemsBlock(d) {
    var cards = (d.priorites_detail || []).map(function (p, i) {
      return (
        '<div class="card priority">' +
        '<span class="rank">0' + (i + 1) + '</span>' +
        '<h3>' + esc(p.label) + '</h3>' +
        '<p>' + esc(EXPLAIN[p.key] || '') + '</p>' +
        '<div class="mini-bar"><i style="width:' + pct(p.score) + '%"></i></div>' +
        '</div>'
      )
    }).join('')
    return (
      '<section><div class="eyebrow">Bloc 3 — Problématiques</div>' +
      '<h2>Vos 3 priorités</h2>' +
      '<p class="sec-sub">Les axes où votre soin apportera le plus de bénéfices visibles.</p>' +
      '<div class="grid">' + cards + '</div></section>'
    )
  }

  function ingredientsBlock(d) {
    var cards = (d.ingredients_recommandes || []).map(function (ing) {
      return (
        '<div class="card">' +
        '<span class="badge ' + esc(ing.pertinence === 'élevée' ? 'elevee' : ing.pertinence) + '">' + esc(ing.pertinence) + '</span>' +
        '<h3 style="margin-top:8px">' + esc(ing.nom) + '</h3>' +
        (ing.inci ? '<p><i>' + esc(ing.inci) + '</i></p>' : '') +
        (ing.benefice ? '<p>' + esc(ing.benefice) + '</p>' : '') +
        (ing.hubUrl ? '<p><a class="btn ghost" style="margin-top:8px" href="' + esc(ing.hubUrl) + '">En savoir plus</a></p>' : '') +
        '</div>'
      )
    }).join('')
    return (
      '<section><div class="eyebrow">Bloc 4 — Ingrédients recommandés</div>' +
      '<h2>Vos actifs ciblés</h2><div class="grid">' + cards + '</div></section>'
    )
  }

  function avoidBlock(d) {
    var items = (d.ingredients_a_eviter || []).map(function (a) {
      return '<li><span class="nom">' + esc(a.nom) + '</span> — ' + esc(a.raison) + '</li>'
    }).join('')
    var pro = d.pro_referral ? '<p class="guardrail">' + esc(d.pro_referral) + '</p>' : ''
    return (
      '<section><div class="eyebrow">Bloc 5 — À éviter ou surveiller</div>' +
      '<h2>Par prudence</h2>' +
      (items ? '<ul class="avoid">' + items + '</ul>' : '<p class="sec-sub">Rien de particulier à signaler selon vos réponses.</p>') +
      '<p class="guardrail">Certains ingrédients peuvent être moins adaptés selon votre sensibilité ou votre situation. En cas de doute, demandez conseil à un professionnel de santé.</p>' +
      pro + '</section>'
    )
  }

  function historiqueBlock(d) {
    var h = d.historique || []
    if (h.length < 2) return '' // on n'affiche le suivi que dès le 2e diagnostic
    var rows = h.map(function (e, i) {
      var older = h[i + 1]
      var delta = (older && e.score_global != null && older.score_global != null) ? (e.score_global - older.score_global) : null
      var date = e.date
      try { date = new Date(e.date).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' }) } catch (er) {}
      var deltaHtml = delta == null
        ? (i === h.length - 1 ? '<span style="color:#a59f93;font-size:12px">premier diagnostic</span>' : '')
        : '<span style="font-size:12px;font-weight:600;color:' + (delta >= 0 ? '#5b9e6b' : '#c98a5a') + '">' + (delta >= 0 ? '▲ +' : '▼ ') + delta + ' pts</span>'
      return (
        '<li style="display:flex;gap:14px;padding:12px 0;border-top:1px solid #f0ece1">' +
        '<span style="flex:0 0 auto;width:12px;height:12px;border-radius:50%;background:' + (i === 0 ? '#b8923f' : '#d9cfb8') + ';margin-top:5px"></span>' +
        '<div style="flex:1"><div><b>' + esc(date) + '</b>' + (i === 0 ? ' <span style="background:#b8923f;color:#fff;border-radius:20px;padding:2px 9px;font-size:11px;font-weight:600">actuel</span>' : '') + '</div>' +
        '<div style="color:#8a8377;font-size:13px;margin-top:2px">Score <b style="color:#2c2a26">' + (e.score_global != null ? e.score_global : '—') + '</b>/100' + (e.type_peau ? ' · ' + esc(e.type_peau) : '') + ' &nbsp;' + deltaHtml + '</div></div></li>'
      )
    }).join('')
    return (
      '<section><div class="eyebrow">Votre suivi dans le temps</div>' +
      '<h2>Historique de vos diagnostics</h2>' +
      '<p class="sec-sub">Chaque diagnostic est conservé — suivez l’évolution de votre score au fil du temps.</p>' +
      '<ul style="list-style:none;margin:0;padding:0">' + rows + '</ul></section>'
    )
  }

  function purchasedBanner(d) {
    var p = d.routine_achetee
    if (!p) return ''
    var when = ''
    if (p.ordered_at) { try { when = new Date(p.ordered_at).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' }) } catch (e) {} }
    var items = (p.items || []).map(function (it) {
      return '<li>' + esc(it.title) + (it.qty > 1 ? ' <span style="opacity:.6">× ' + esc(it.qty) + '</span>' : '') + '</li>'
    }).join('')
    var title = p.is_routine ? (p.routine_name || 'Votre routine') : 'Votre dernier achat'
    return (
      '<div class="purchased" style="border:1px solid rgba(184,146,63,.45);background:linear-gradient(135deg,rgba(184,146,63,.10),rgba(184,146,63,.02));border-radius:16px;padding:18px 20px;margin:0 0 18px">' +
      '<div class="eyebrow" style="color:#b8923f">✓ Routine achetée' + (when ? ' — ' + esc(when) : '') + '</div>' +
      '<h3 style="margin:6px 0 8px">' + esc(title) + (p.order_number ? ' <span style="font-weight:400;opacity:.6;font-size:.8em">' + esc(p.order_number) + '</span>' : '') + '</h3>' +
      (items ? '<ul style="margin:0;padding-left:18px;line-height:1.7">' + items + '</ul>' : '') +
      '</div>'
    )
  }

  function routinesBlock(d) {
    var prod = (d.produits_recommandes || [])[0]
    var soin = prod ? prod.nom : 'votre soin NOPAL LIFE'
    var sig = (d.ingredients_recommandes || [])[0]
    var sigNom = sig ? sig.nom : 'l’actif signature'
    function step(t, dd) { return '<li><span class="t">' + esc(t) + '</span><br><span class="d">' + esc(dd) + '</span></li>' }
    var matin =
      step('Nettoyer en douceur', 'Un nettoyant doux pour préserver le confort.') +
      step('Hydrater / apaiser', 'Préparer la peau à recevoir le soin.') +
      step('Appliquer le soin recommandé', soin) +
      step('Protéger (SPF)', 'Indispensable au quotidien pour préserver les résultats.')
    var soir =
      step('Démaquiller / nettoyer', 'Retirer impuretés et résidus de la journée.') +
      step('Soin ciblé', 'Mettre en avant ' + sigNom + '.') +
      step('Nourrir / réparer', 'Huile de pépins de figue de barbarie pour la nuit.') +
      step('Masser', 'Quelques mouvements pour stimuler l’éclat.')
    var intro = d.routine_achetee
      ? 'Votre routine achetée, et le rituel matin & soir pour en tirer le meilleur.'
      : 'Le rituel matin & soir recommandé selon votre profil.'
    return (
      '<section><div class="eyebrow">Blocs 6 & 7 — Vos routines</div>' +
      '<h2>Matin & soir</h2>' +
      '<p class="sec-sub">' + esc(intro) + '</p>' +
      purchasedBanner(d) +
      '<div class="routines">' +
      '<div class="routine"><h3>☀️ Routine matin</h3><ol class="steps">' + matin + '</ol></div>' +
      '<div class="routine"><h3>🌙 Routine soir</h3><ol class="steps">' + soir + '</ol></div>' +
      '</div></section>'
    )
  }

  function productsBlock(d) {
    var cards = (d.produits_recommandes || []).map(function (p) {
      var url = p.urlShopify || '#'
      return (
        '<div class="card"><div class="product">' +
        '<div class="thumb">✿</div>' +
        '<div><h3>' + esc(p.nom) + '</h3><p>' + esc(p.raison || '') + '</p>' +
        '<div class="btns"><a class="btn primary" href="' + esc(url) + '">Ajouter au panier</a>' +
        '<a class="btn ghost" href="' + esc(url) + '">En savoir plus</a></div></div>' +
        '</div></div>'
      )
    }).join('')
    return (
      '<section><div class="eyebrow">Bloc 8 — Produits NOPAL LIFE</div>' +
      '<h2>Recommandés pour vous</h2><div class="grid">' + cards + '</div></section>'
    )
  }

  function contentsBlock(d) {
    var TAG = { article: 'Article', fiche: 'Fiche', probleme: 'Guide' }
    var rows = (d.articles_recommandes || []).map(function (c) {
      return (
        '<a class="read" href="' + esc(c.url) + '">' +
        '<span class="tag">' + esc(TAG[c.type] || 'Lire') + '</span>' +
        '<span>' + esc(c.titre) + '</span></a>'
      )
    }).join('')
    return (
      '<section><div class="eyebrow">Bloc 9 — À lire</div>' +
      '<h2>Pour aller plus loin</h2><div class="reads">' + rows + '</div></section>'
    )
  }

  function goalsBlock(d) {
    return (
      '<section><div class="eyebrow">Bloc 10 — Objectifs</div>' +
      '<h2>Votre feuille de route</h2>' +
      '<div class="goals">' +
      '<div class="goal"><div class="h">30 jours</div><p>Améliorer le confort, la régularité de routine et l’éclat du teint.</p></div>' +
      '<div class="goal"><div class="h">90 jours</div><p>Suivre l’évolution de l’uniformité du teint, de la fermeté et de l’hydratation.</p></div>' +
      '</div></section>'
    )
  }

  function pdfBtn(cls) {
    return '<a class="btn ' + cls + '" id="nld-pdf" href="#">⤓ Télécharger en PDF</a>'
  }

  function ctaBlock(d) {
    if (d.saved) {
      // Espace membre : dossier déjà enregistré → proposer le téléchargement PDF.
      return (
        '<div class="save"><div class="inner">' +
        '<div><h3>Votre dossier est enregistré</h3>' +
        '<p>Téléchargez-le en PDF pour le conserver ou l’imprimer.</p></div>' +
        pdfBtn('primary') +
        '</div></div>'
      )
    }
    // Aperçu (non sauvegardé) : proposer la sauvegarde + le PDF.
    return (
      '<div class="save"><div class="inner">' +
      '<div><h3>Gardez votre Dossier Peau</h3>' +
      '<p>Créez votre espace privé : suivi dans le temps, PDF, et comparaison à J+30.</p>' +
      '<div id="nld-save-msg" style="margin-top:10px;font-size:13px;color:#d9d2c6"></div></div>' +
      '<div class="nld-actions">' +
      '<a class="btn primary" id="nld-save" href="#">Sauvegarder mon dossier</a>' +
      pdfBtn('ghost') +
      '</div></div></div>'
    )
  }

  function wirePdf(mount) {
    var b = mount.querySelector('#nld-pdf')
    if (b) b.addEventListener('click', function (e) { e.preventDefault(); window.print() })
  }

  function linkAccount(claim, opts, consent, cb) {
    var cust = opts.customer || {}
    var payload = { claim_token: claim, consent: !!consent }
    if (cust.id) {
      payload.shopify_customer_id = cust.id
      payload.email = cust.email
      payload.first_name = cust.first_name
    }
    fetch((opts.endpoint || '') + '/v1/account/link', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (r) { return r.json() })
      .then(cb)
      .catch(function () { cb({ error: 'network' }) })
  }

  function wireSave(d, mount, opts) {
    var btn = mount.querySelector('#nld-save')
    var msg = mount.querySelector('#nld-save-msg')
    if (!btn || !msg) return
    btn.addEventListener('click', function (e) {
      e.preventDefault()
      if (!d.claim_token) { msg.textContent = 'Sauvegarde indisponible pour le moment.'; return }
      var policy = opts.policyUrl || '/policies/privacy-policy'
      msg.innerHTML =
        '<label style="display:flex;gap:8px;align-items:flex-start;color:#fff;margin:6px 0 10px">' +
        '<input type="checkbox" id="nld-consent" style="margin-top:3px"> ' +
        '<span>J\'accepte que mon Dossier Peau soit conservé pour mon suivi (consultable, exportable et supprimable à tout moment). ' +
        '<a href="' + policy + '" style="color:#cbb07a;text-decoration:underline">Confidentialité</a></span></label>' +
        '<a class="btn primary" id="nld-confirm" href="#">Confirmer la sauvegarde</a>'
      mount.querySelector('#nld-confirm').addEventListener('click', function (ev) {
        ev.preventDefault()
        if (!mount.querySelector('#nld-consent').checked) { msg.querySelector('span').style.color = '#f0c0a0'; return }
        var cust = opts.customer || {}
        if (!cust.id) {
          try { localStorage.setItem('nopal_pending_claim', JSON.stringify({ claim: d.claim_token })) } catch (er) {}
          window.location.href = opts.accountUrl || '/account/register'
          return
        }
        msg.textContent = 'Sauvegarde…'
        linkAccount(d.claim_token, opts, true, function (res) {
          msg.textContent = res && res.linked ? '✓ Dossier sauvegardé dans votre compte.' : 'Échec de la sauvegarde, réessayez.'
        })
      })
    })
  }

  // Retour depuis la création de compte : rattache automatiquement le dossier en attente.
  function checkPendingLink(opts, mount) {
    var cust = opts.customer || {}
    if (!cust.id) return
    var pending = null
    try { pending = JSON.parse(localStorage.getItem('nopal_pending_claim') || 'null') } catch (e) {}
    if (!pending || !pending.claim) return
    linkAccount(pending.claim, opts, true, function (res) {
      try { localStorage.removeItem('nopal_pending_claim') } catch (e) {}
      var msg = mount.querySelector('#nld-save-msg')
      if (msg && res && res.linked) msg.textContent = '✓ Dossier sauvegardé dans votre compte.'
    })
  }

  // Accueil d'une cliente qui a ACHETÉ mais pas encore fait de diagnostic : on montre sa routine + on invite au diagnostic.
  window.renderPurchaseWelcome = function (d, mount, opts) {
    opts = opts || {}
    if (!d || !mount) return
    var prenom = opts.prenom || 'cliente'
    mount.innerHTML =
      '<div class="nld">' +
      '<section class="hero">' +
      '<div class="eyebrow">Votre espace NOPAL LIFE</div>' +
      '<h1>Bonjour ' + esc(prenom) + '</h1>' +
      '<p class="lede">Merci pour votre confiance. Voici votre routine — et pour débloquer vos <b>recommandations personnalisées</b>, faites votre diagnostic de peau (2 min, gratuit).</p>' +
      '</section>' +
      '<section><div class="eyebrow">Votre routine</div><h2>Ce que vous avez choisi</h2>' + purchasedBanner(d) + '</section>' +
      '<div class="save"><div class="inner">' +
      '<div><h3>Faites votre diagnostic de peau</h3>' +
      '<p>Découvrez votre profil cosmétique, vos ingrédients ciblés et votre routine sur-mesure — et suivez votre évolution dans le temps.</p></div>' +
      '<a class="btn primary" href="/pages/diagnostic">Faire mon diagnostic gratuit</a>' +
      '</div></div>' +
      '</div>'
  }

  window.renderDossier = function (d, mount, opts) {
    opts = opts || {}
    if (!d || !mount) return
    mount.innerHTML =
      '<div class="nld">' +
      hero(d, opts.prenom || 'cliente') +
      scoreBlock(d) +
      historiqueBlock(d) +
      problemsBlock(d) +
      ingredientsBlock(d) +
      avoidBlock(d) +
      routinesBlock(d) +
      productsBlock(d) +
      contentsBlock(d) +
      goalsBlock(d) +
      ctaBlock(d) +
      '</div>'
    wireSave(d, mount, opts)
    wirePdf(mount)
    checkPendingLink(opts, mount)
  }
})()
